import { render, staticRenderFns } from "./ProfitAndCashFlowChartsPlaceholderType.vue?vue&type=template&id=b84fa266&scoped=true"
import script from "./ProfitAndCashFlowChartsPlaceholderType.vue?vue&type=script&lang=js"
export * from "./ProfitAndCashFlowChartsPlaceholderType.vue?vue&type=script&lang=js"
import style0 from "./ProfitAndCashFlowChartsPlaceholderType.vue?vue&type=style&index=0&id=b84fa266&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84fa266",
  null
  
)

export default component.exports